import React from 'react'
import PropTypes from 'prop-types'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import { TRANSFER_DETAIL_PATH } from '~/constants/routes'
import { TRANSFER_DETAIL_TABS } from '~/constants/tabs'

function TransferDetailTabs ({ value }) {
  const navigate = useNavigate()
  const { guid } = useParams()
  const onChange = (event, tab) => {
    const redirect = generatePath(TRANSFER_DETAIL_PATH, { guid, tab })

    navigate(redirect, { replace: true })
  }

  const tabs = [
    { value: TRANSFER_DETAIL_TABS.GENERAL, label: 'General' },
    { value: TRANSFER_DETAIL_TABS.HISTORY, label: `History` }
  ]

  return (
    <Tabs
      tabs={tabs}
      value={value}
      onChange={onChange}
    />
  )
}

TransferDetailTabs.propTypes = {
  value: PropTypes.string.isRequired
}

export default TransferDetailTabs
